declare var globalTags;

export const getTranslation = key => {
    
    // global javascript file check on existance
    if (typeof globalTags === "undefined") {
        console.error("Language tags are not imported");
        return "{" + key + "}";
    }

    for (let tag of globalTags) {
        if (tag.key.toString().toLowerCase() === key.toString().toLowerCase()) {
            return tag.value;
        }
    }

    console.warn("Language key " + key + " is not available");
    if (key.indexOf(".") > -1) {
        return "{" + key.substring(key.lastIndexOf(".")) + "}";
    }

    return "{" + key + "}";
}


// WEBPACK FOOTER //
// ./src/Utilities/GetTranslation.js